import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SigninFormLiteService } from '../components/signin-form-lite/signin-form-lite.service';
import { Subscription } from 'rxjs';
import { SignupFormLiteService } from '../components/signup-form-lite/signup-form-lite.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-auth-light-popin',
  templateUrl: './auth-light-popin.component.html',
  styleUrls: ['./auth-light-popin.component.scss']
})
export class AuthLightPopinComponent implements OnInit, OnDestroy {
  submitted = false;
  showFormRegister = false;
  private loginSubscription: Subscription;
  private registerSubscription: Subscription;

  @Input() title = $localize`:@@auth.light.title:Kozikaza`;
  @Input() createAccountLabel = $localize`:@@auth.light.create-account:We will create a Kozikaza account so that you can discuss with your consultant and manage your project.`;

  constructor(
    private signinFormLiteService: SigninFormLiteService,
    private signupFormLiteService: SignupFormLiteService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.loginSubscription = this.signinFormLiteService.submitted.pipe(
      tap((value) => this.submitted = !!value),
      tap(() => this.cdr.detectChanges()),
    ).subscribe();
  }

  login(): void {
    this.signinFormLiteService.submitted.next(true);
  }

  register(): void {
    this.signupFormLiteService.signupForm.markAllAsTouched();

    if (this.signupFormLiteService.signupForm.valid) {
      this.submitted = true;

      this.registerSubscription = this.signupFormLiteService.save().subscribe();
    }
  }

  ngOnDestroy(): void {
    if (this.loginSubscription && !this.loginSubscription.closed) {
      this.loginSubscription.unsubscribe();
    }
    if (this.registerSubscription && !this.registerSubscription.closed) {
      this.registerSubscription.unsubscribe();
    }
  }
}
